/**
 * Ryan O'Dowd
 * 2024-11-11
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import Text from '@components/common/Text';
import getStyles from './styles';
import hooks from '@hooks';

const PopoverText = (props: PopoverTextProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <Text
      style={[
        styles.container,
        props.title && styles.titleText,
        props.style,
      ]}
    >
      {props.children}
    </Text>
  );
};

class PopoverTextProps {
  children: React.ReactNode;

  style?: any;
  title?: boolean;
};

export default PopoverText;
